import React, { useState, useCallback } from "react";
import Reveal from "../common/Reveal";

const Contact: React.FC = () => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText("admin@ukuleleseekho.com");
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  }, []);

  return (
    <section
      id="contact"
      className="relative bg-gradient-to-b from-primary via-primary/95 to-primary/90 py-20 sm:py-24"
    >
      <div className="absolute inset-x-0 top-0 h-20 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.12),_transparent_70%)]" />
      <div className="absolute inset-x-0 bottom-0 h-32 bg-[radial-gradient(circle_at_bottom,_rgba(255,255,255,0.08),_transparent_70%)]" />

      <div className="relative mx-auto flex max-w-6xl flex-col gap-12 px-6">
        <Reveal className="text-center space-y-5">
          <p className="text-xs uppercase tracking-[0.35em] text-accentNavy/45">
            Get in Touch
          </p>
          <h2 className="font-display text-3xl text-accentNavy sm:text-4xl lg:text-5xl">
            Contact Us
          </h2>
          <p className="mx-auto max-w-2xl text-base text-accentNavy/70 lg:text-lg">
            Have questions or ready to start your ukulele journey? We're here to help!
          </p>
        </Reveal>

        <Reveal delay={120}>
          <div className="mx-auto max-w-3xl">
            <div className="grid gap-6 sm:grid-cols-3">
              {/* WhatsApp */}
              <a
                href="https://wa.me/9116559114?text=Hi%2C%20I%E2%80%99d%20like%20to%20inquire%20about%20availability%20for%20a%20demo%20class%20this%20week."
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex flex-col items-center gap-4 rounded-3xl border border-white/50 bg-white/90 p-8 text-center shadow-[0_20px_50px_-30px_rgba(9,32,63,0.3)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_-25px_rgba(9,32,63,0.4)] hover:border-accentGold/30"
              >
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100 transition-transform duration-300 group-hover:scale-110">
                  <svg
                    className="h-8 w-8 text-green-600"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-accentNavy mb-1">WhatsApp</h3>
                  <p className="text-sm text-accentNavy/60">+91 9116559114</p>
                  <p className="text-xs text-accentGold font-medium mt-2">
                    (Get faster reply)
                  </p>
                </div>
              </a>

              {/* Email */}
              <div
                onClick={handleCopy}
                className="group relative flex flex-col items-center gap-4 rounded-3xl border border-white/50 bg-white/90 p-8 text-center shadow-[0_20px_50px_-30px_rgba(9,32,63,0.3)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_-25px_rgba(9,32,63,0.4)] hover:border-accentGold/30 cursor-pointer"
              >
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-accentNavy/10 transition-transform duration-300 group-hover:scale-110">
                  <svg
                    className="h-8 w-8 text-accentNavy"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-accentNavy mb-1">Email</h3>
                  <p className="text-sm text-accentNavy/60">
                    {isCopied ? "Copied!" : "admin@ukuleleseekho.com"}
                  </p>
                </div>
              </div>

              {/* Instagram */}
              <a
                href="https://instagram.com/ukuleleseekho"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative flex flex-col items-center gap-4 rounded-3xl border border-white/50 bg-white/90 p-8 text-center shadow-[0_20px_50px_-30px_rgba(9,32,63,0.3)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_-25px_rgba(9,32,63,0.4)] hover:border-accentGold/30"
              >
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-purple-500 via-pink-500 to-orange-500 transition-transform duration-300 group-hover:scale-110">
                  <svg
                    className="h-8 w-8 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-accentNavy mb-1">Instagram</h3>
                  <p className="text-sm text-accentNavy/60">@ukuleleseekho</p>
                </div>
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;

